<template>
  <details class="user-activity-summary">
    <summary>Son yüklenen hareketler</summary>
    <v-simple-table dense>
      <thead><tr><th>Zaman</th><th>Kaynak</th><th>Kayıt</th><th>Durum</th><th></th></tr></thead>
      <tbody>
        <tr
          v-for="item in rows"
          :key="item.key"
        >
          <td>{{ formatDate(item.at) }}</td><td>{{ item.source }}</td><td>{{ item.title }}</td><td>{{ item.status || '-' }}</td><td>
            <v-btn
              small
              text
              @click="$emit('select-tab', item.tab)"
            >
              İncele
            </v-btn>
          </td>
        </tr>
        <tr v-if="!rows.length">
          <td colspan="5">
            Yüklenen kayıtlarda tarihli hareket bulunamadı.
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </details>
</template>
<script>
import { formatAdminDate, parseAdminDate } from '@/utils/adminDate'

const SOURCES = [
  {
    key: 'links', source: 'Link', date: 'created', title: 'name', tab: 0,
  },
  {
    key: 'pointTransactions', source: 'Puan', date: 'effectiveAt', title: 'description', tab: 1,
  },
  {
    key: 'walletTransitions', source: 'Mutabakat', date: 'systemAt', title: 'reason', tab: 2,
  },
  {
    key: 'walletTransactions', source: 'Cüzdan', date: 'entryDate', title: 'linkName', tab: 3,
  },
  {
    key: 'analyticsEvents', source: 'Event', date: 'occurredAt', title: 'eventName', tab: 4,
  },
  {
    key: 'notifications', source: 'Bildirim', date: 'date', title: 'title', tab: 5,
  },
  {
    key: 'withdrawRequests', source: 'Para çekme', date: 'requestedAt', title: 'bankName', tab: 7,
  },
]

export default {
  props: { dashboard: { type: Object, required: true } },
  computed: {
    rows() {
      return SOURCES.flatMap(source => (this.dashboard[source.key] || []).map((item, index) => ({
        key: `${source.key}:${item.id || index}`,
        at: item[source.date],
        timestamp: parseAdminDate(item[source.date])?.getTime(),
        source: source.source,
        title: item[source.title] || `#${item.id || '-'}`,
        status: item.status,
        tab: source.tab,
      }))).filter(row => Number.isFinite(row.timestamp)).sort((a, b) => b.timestamp - a.timestamp || a.key.localeCompare(b.key)).slice(0, 30)
    },
  },
  methods: { formatDate: formatAdminDate },
}
</script>
<style scoped>
.user-activity-summary { margin: 12px 0; border-block: 1px solid var(--admin-border); }
.user-activity-summary summary { padding: 12px 0; cursor: pointer; font-weight: 600; }
.user-activity-summary td { max-width: 320px; overflow-wrap: anywhere; }
</style>
